<template lang="html">
    <div class="checkout__body">
        <ul class="checkout__steps">
            <li class="checkout-step" >
                <div class="checkout-step__top">
                    <div class="checkout-step__counter"><span>03</span></div>
                    <h3 class="checkout-step__title">Записаться на шиномонтаж</h3>
                    <span class="checkout-step__toggler" ></span>
                </div>
                <div class="checkout-step__inner">
                    <div v-show="!isTerminal || !favCenter.ID" class="checkout-step__item">
                        <span class="checkout-step__item-name">сервисный центр</span>
                        <div class="checkout-step__form">
                            <div class="checkout-step__form-item checkout-form">
                                <div class="checkout-form__items">
                                    <div class="form-item required">
                                        <label class="form-item__label">Сервис</label>
                                        <div class="default-select" :key="selectedCenterId" >
                                            <roscar-select >
                                                <select class="default-select__select" v-model="selectedCenterId" data-placeholder="Выберите сервис" data-no-deselect="true">
                                                    <option data-placeholder="true"></option>
                                                    <option v-for="item in availableCenters" :key="item.ID" :value="item.ID" >{{ item.ADDRESS }}</option>
                                                </select>
                                            </roscar-select>
                                        </div>
                                    </div>
                                    <a v-if="availableCenters.length" class="link" href="#" @click.prevent="$refs.availableStoresPopup.open()" >показать на карте</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="checkout-step__item">
                        <span class="checkout-step__item-name">выбрать дату</span>
                        <div class="checkout-step__form">
                            <div class="checkout-step__form-item checkout-form">
                                <div class="checkout-form__items">
                                    <div class="form-item form-item--daytime">
                                        <label class="form-item__label">Выбрать дату</label>
                                        <div class="default-calendar">
                                            <roscar-calendar :modelValue="selectedDate" @update:modelValue="selectedDate = $event[0]" ></roscar-calendar>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedDate && selectedCenterId" class="checkout-step__item">
                        <span class="checkout-step__item-name">выбрать время</span>
                        <div class="checkout-step__form">
                            <div class="checkout-step__form-item checkout-form">
                                <div class="checkout-form__items">
                                    <div class="form-item form-item--daytime">
                                        <label class="form-item__label">Выбрать время</label>
                                        <ul v-if="availableTime.length" class="default-timeselect">
                                            <li v-for="time in availableTime" :key="time" @click.prevent="selectTime(time)" class="default-timeselect__item" :class="{ 'default-timeselect__item--active' : selectedTime == time }" >{{ time }}</li>
                                        </ul>
                                        <div v-else-if="availableTimeLoaded" >
                                            На указанную дату нет доступного времени
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="checkout-step__item">
                        <span class="checkout-step__item-name">личные данные</span>
                        <div class="checkout-step__form">
                            <div v-if="personalCars.length" class="checkout-step__form-item checkout-step__form-item--wide" >
                                <p class="checkout-step__text">Выберите ваш автомобиль для экономии времени заполнения заявки.<br>При выборе автомобиля все параметры подставятся автоматически</p>
                            </div>
                            <div class="checkout-step__form-item checkout-form">
                                <div class="checkout-form__items">
                                    <div v-if="personalCars.length" class="form-item">
                                        <label class="form-item__label">Ваш автомобиль</label>
                                        <div class="default-select">
                                            <roscar-select v-model="selectedPersonalCarId" v-slot="slotProps" >
                                                <select :ref="el => slotProps.params.selectElement = el" v-model="selectedPersonalCarId" class="default-select__select" data-placeholder="Выберите автомобиль" data-no-deselect="true">
                                                    <option data-placeholder="true"></option>
                                                    <option v-for="item in personalCars" :key="item.ID" :value="item.ID" >{{ item.UF_BRAND }} {{ item.UF_MODEL }} {{ item.UF_SHELL }}, {{ item.UF_YEAR }}</option>
                                                </select>
                                            </roscar-select>
                                        </div>
                                    </div>

                                    <car-selector v-slot="carSelectorSlotProps" :type="[ 'cars' ]"
                                    v-model:brand="car.brand"
                                    v-model:model="car.model"
                                    >
                                    <div class="form-item required">
                                        <label class="form-item__label">Марка</label>
                                        <div class="default-select" :key="carSelectorSlotProps.params.brand" >
                                            <roscar-select>
                                                <select v-model="carSelectorSlotProps.params.brand" class="default-select__select" data-placeholder="Выберите марку авто" data-no-deselect="true">
                                                    <option data-placeholder="true"></option>
                                                    <option v-for="val in carSelectorSlotProps.brands" :key="val" :value="val" v-html="val" ></option>
                                                </select>
                                            </roscar-select>
                                        </div>
                                    </div>
                                    <div v-if="carSelectorSlotProps.models.length" class="form-item required">
                                        <label class="form-item__label">Модель</label>
                                        <div class="default-select" :key="carSelectorSlotProps.params.model" >
                                            <roscar-select>
                                                <select v-model="carSelectorSlotProps.params.model" class="default-select__select" data-placeholder="Выберите модель авто" data-no-deselect="true">
                                                    <option data-placeholder="true"></option>
                                                    <option v-for="val in carSelectorSlotProps.models" :key="val" :value="val" v-html="val" ></option>
                                                </select>
                                            </roscar-select>
                                        </div>
                                    </div>
                                </car-selector>
                                <div class="form-item required">
                                    <label class="form-item__label">Госномер</label>
                                    <div class="default-input">
                                        <input-mask v-keyboard.right.car.mask v-model="car.licenseNumber" required placeholder="Введите госномер автомобиля" :definitions="{ 'x' : /[аАвВеЕкКмМнНоОрРсСтТуУхХ]/ }" mask="x000xx" ></input-mask>
                                    </div>
                                </div>
                                <div class="form-item">
                                    <label class="simple-checkbox">
                                        <input v-model="tiresStored" class="simple-checkbox__input" type="checkbox" value="1" />
                                        <span class="simple-checkbox__title">мои шины хранятся у вас</span>
                                    </label>
                                </div>
                                <div v-if="+tiresStored" class="form-item">
                                    <label class="form-item__label">Номер договора</label>
                                    <div class="default-input">
                                        <input-mask v-keyboard.right.mask v-model="client.contractNumber" :required="!!+tiresStored" @change="client.contractNumber = client.contractNumber.toUpperCase(); checkContractNumber()" type="text" placeholder="XXX-00000000" mask="aaa-00000000" ></input-mask>
                                    </div>
                                </div>
                                <div class="form-item required">
                                    <label class="form-item__label">ФИО</label>
                                    <div class="default-input">
                                        <input v-keyboard.right.fio v-model="client.name" type="text" placeholder="Введите ваши ФИО" required />
                                    </div>
                                </div>
                                <div class="form-item required">
                                    <label class="form-item__label">Контактный телефон</label>
                                    <div class="default-input">
                                        <input-phone v-keyboard.right.phone.mask v-model="client.phone" required ></input-phone>
                                    </div>
                                </div>
                                <div class="checkout-form__suggestion">
                                    <slot name="policy"></slot>
                                </div>
                                <div class="checkout-form__submit">
                                    <button v-if="+tiresStored && !contractNumberChecked" class="btn disabled" >Оставить заявку на сервис</button>
                                    <button v-else class="btn" @click.prevent="submit()" >Оставить заявку на сервис</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
    <article class="service-total">
        <ul v-if="selectedCenter.ADDRESS || selectedDateFormatted || selectedService.ID" class="service-total__info">
            <li v-if="selectedCenter.ADDRESS" class="service-total__info-item"><span class="service-total__info-label">Сервисный центр</span>
                <p>{{ selectedCenter.ADDRESS || ' - ' }}</p>
            </li>
            <li v-if="selectedDateFormatted" class="service-total__info-item"><span class="service-total__info-label">Дата и время</span>
                <p>{{ [ selectedDateFormatted, selectedTime ].filter(v=>v).join(', ') || ' - ' }}</p>
            </li>
            <li v-if="selectedService.ID" class="service-total__info-item"><span class="service-total__info-label">Стоимость шиномонтажа</span>
                <p>{{ selectedService.UF_NAME }}</p>
                <p v-if="selectedService.PRICE" >{{ $filters.priceFormat(selectedService.PRICE) }} ₽</p>
            </li>
        </ul>
        <div class="service-total__count">
            <a class="link" href="#" @click.prevent="$refs.tireFittingPricePopup.open();" >Рассчитать стоимость шиномонтажа?</a>
        </div>
    </article>
    <div class="checkout__bottom">
        <div class="checkout__suggestion">
            <slot name="policy-right"></slot>
        </div>
        <div class="checkout__submit">
            <button v-if="+tiresStored && !contractNumberChecked" class="btn disabled" >Оставить заявку на сервис</button>
            <button v-else class="btn" @click.prevent="submit()" >Оставить заявку на сервис</button>
        </div>
    </div>
</div>

<popup-block ref="serviceOrderCompletePopup" type="right" @close="goTo('/')" >
    <div class="popup__title">
        <h2 class="popup__title-title">Запись оформлена</h2>
    </div>
    <p class="popup__text popup__text--bold">
        Спасибо, в ближайшее время Вам придет SMS с  подтверждением даты и времени.
        <br/><br/>
        <a v-if="calendarLink" :href="calendarLink" :target="~calendarLink.indexOf('://') ? '_blank' : false" class="link">Добавить запись в календарь</a>
    </p>
</popup-block>

<popup-block v-slot:default="availableStoresPopupSlotProps" ref="availableStoresPopup" type="right" class="popup--map" >
    <stores-list-map >
        <template v-slot:map >
            <yandex-map :placemarks="mapPlacemarks" height="100%" @placemark:selected="mapPlacemarkSelected($event); availableStoresPopupSlotProps.close();" ></yandex-map>
        </template>
        <template v-slot:list >
            <label v-for="item in availableCenters" :key="item.STORE_ID" class="services-list__item" >
                <input type="radio" :checked="selectedCenterId == item.ID" :value="selectedCenterId" name="selected_store_id" />
                <span class="services-list__item-radio"></span>
                <div class="services-list__item-desc">
                    <p class="services-list__item-name">{{ item.ADDRESS }}</p>
                    <ul class="services-list__item-schedule">
                        <li v-if="item.WORK_DAYS_START && item.WORK_DAYS_END" >Пн-Пт: {{ item.WORK_DAYS_START }} - {{ item.WORK_DAYS_END }}</li>
                        <li v-if="item.WORK_SAT_START && item.WORK_SAT_START == item.WORK_SUNDAY_START && item.WORK_SAT_END == item.WORK_SUNDAY_END" >
                            Сб-Вс: {{ [ item.WORK_SAT_START, (item.WORK_SAT_END != item.WORK_SAT_START ? item.WORK_SAT_END : '') ].filter(v=>v).join(' - ') }}
                        </li>
                        <template v-else >
                            <li v-if="item.WORK_SAT_START" >Сб: {{ [ item.WORK_SAT_START, (item.WORK_SAT_END != item.WORK_SAT_START ? item.WORK_SAT_END : '') ].filter(v=>v).join(' - ') }}</li>
                            <li v-if="item.WORK_SUNDAY_START" >Вс: {{ [ item.WORK_SUNDAY_START, (item.WORK_SUNDAY_END != item.WORK_SUNDAY_START ? item.WORK_SUNDAY_END : '') ].filter(v=>v).join(' - ') }}</li>
                        </template>
                    </ul>
                    <button @click.prevent="selectedCenterId = item.ID; availableStoresPopupSlotProps.close();" class="btn">Выбрать</button>
                </div>
            </label>
        </template>
    </stores-list-map>
</popup-block>


<popup-block ref="tireFittingPricePopup" v-slot="tireFittingPricePopupSlotProps" type="right" >
    <div class="popup__title">
        <h2 class="popup__title-title">Рассчитать  стоимость</h2>
    </div>
    <tire-fitting-price @service-code:selected="selectedServiceCode = $event" @continue="tireFittingPricePopupSlotProps.close()" ></tire-fitting-price>
</popup-block>

</template>

<script>
import { ref, watch, computed, onMounted } from 'vue';
import { loadTireServices, loadServiceCentersByServices, loadServiceCenterAvailableTime, submitServiceOrder, getTireStoreContract, } from '../../api';
import usePersonalCars from '../../composables/usePersonalCars';
import useCities from '../../composables/useCities';
import RoscarCalendar from './../RoscarCalendar';
import useInitData from '../../composables/useInitData';
import showMessage from '../../modules/showMessage';

export default {
    name : 'ServiceOrderTireFitting',
    props : {
        isTerminal : {
            type : Boolean,
            default : false,
        }
    },
    components : {
        RoscarCalendar,
    },
    setup () {
        const personalCars = usePersonalCars().cars;
        if (!personalCars.length) {
            usePersonalCars().load();
        }
        const selectedPersonalCarId = ref('');
        const tireFittingPricePopup = ref(null);
        const serviceOrderCompletePopup = ref(null);
        const serviceType = ref(null);
        const tiresStored = ref(0);
        const selectedDate = ref('');
        const selectedTime = ref('');
        const selectedCenterId = ref('');
        const services = ref([]);
        const car = ref({
            brand : '',
            model : '',
            licenseNumber : '',
        });
        loadTireServices().then(res => {
            services.value = res.items || [];
        })
        const selectedServiceCode = ref('');
        const selectedService = computed(()=>{
            return services.value.find(s => s.UF_CODE == selectedServiceCode.value) || {};
        });
        const calendarLink = ref('');
        watch(selectedPersonalCarId, () => {
            let personalCar = personalCars.value.find(c => c.ID == selectedPersonalCarId.value);
            if (personalCar) {
                car.value.brand = personalCar.UF_BRAND;
                car.value.model = personalCar.UF_MODEL;
                car.value.licenseNumber = personalCar.UF_LICENSE_NUMBER;
            }
        });

        watch(() => car.value.brand, (val, oldVal) => {
            if (oldVal) {
                selectedPersonalCarId.value = '';
            }
        });
        watch(() => car.value.model, (val, oldVal) => {
            if (oldVal) {
                selectedPersonalCarId.value = '';
            }
        });
        const order = ref({
            id : '',
        });
        const initData = useInitData().data;
        const client = ref({
            name : !initData.value.isTerminal ? initData.value.NAME : '',
            phone : !initData.value.isTerminal ? initData.value.PERSONAL_PHONE : '',
            contractNumber : '',
        });
        watch(initData, ()=>{
            client.value.name = !initData.value.isTerminal ? initData.value.NAME : '';
            client.value.phone = !initData.value.isTerminal ? initData.value.PERSONAL_PHONE : '';
        });
        const selectedServices = ref({});
        const availableCenters = ref([]);
        const availableTime = ref([]);
        const selectServiceType = (type) => {
            serviceType.value = type;
        }
        onMounted(() => {
            updateAvailableStores();
        })
        watch(serviceType, () => {
            updateAvailableStores();
        });

        const { selectedCityId } = useCities();
        watch(selectedCityId, () => {
            setTimeout(()=>{
                updateAvailableStores();
            }, 100);
        });
        const selectedCenter = computed(() => availableCenters.value.find(c => c.ID == selectedCenterId.value) || {});
        watch(availableCenters, () => {
            if (selectedCenterId.value && !availableCenters.value.find(c => c.ID == selectedCenterId.value)) {
                selectedCenterId.value = '';
            }

            if (availableCenters.value.length === 1) {
                selectedCenterId.value = availableCenters.value[0].ID;
            }
        });
        const availableTimeLoaded = ref(false);
        watch(selectedCenterId, () => {
            checkContractNumber();
        });
        watch([ selectedCenterId, selectedDate ], () => {
            availableTime.value = [];
            availableTimeLoaded.value = false;
            if (selectedDate.value && selectedCenterId.value) {
                let params = {};
                params[ 'services[]' ] = selectedService.value.UF_CODE || 21834;
                loadServiceCenterAvailableTime(selectedCenter.value.CODE, selectedDate.value, params).then(res => {
                    availableTimeLoaded.value = true;
                    availableTime.value = res.items || [];
                });
            }
        });
        watch(availableTime, () => {
            if (
                selectedTime.value &&
                !~availableTime.value.indexOf(selectedTime.value)
            ) {
                selectedTime.value = '';
            }
        });
        const updateAvailableStores = () => {
            availableCenters.value = [];
            let filterData = new FormData();
            filterData.append('services[]', selectedService.value.UF_CODE || 21834);
            loadServiceCentersByServices(filterData).then(res => {
                availableCenters.value = res.items || [];
                if (res.message) {
                    showMessage(res.message);
                }
            });
        }

        const selectTime = time => {
            if (~availableTime.value.indexOf(time)) {
                selectedTime.value = time;
            }
        }

        const selectedDateFormatted = computed(() => {
            if (!selectedDate.value) {
                return '';
            }
            let dateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
                month: 'long',
                day: 'numeric',
            });
            return dateTimeFormat.format(new Date(selectedDate.value));
        });

        const validate = () => {
            let valid = true;
            if (client.value.phone.replace(/[^\d]/g, '').length != 11) {
                valid = false;
            }
            if ([
                car.value.brand,
                car.value.model,
                car.value.licenseNumber,
                client.value.name,
                selectedDate.value,
                selectedTime.value,
                selectedCenterId.value,
            ].filter(v => !v).length) {
                valid = false;
            }
            return {
                valid
            };
        }

        const openCompletePopup = () => {
            serviceOrderCompletePopup.value.open();
        }

        const submit = () => {
            let validateResult = validate();
            if (!validateResult.valid) {
                showMessage('Заполните обязательные поля');
                return;
            }
            let data = new FormData();
            data.append('centerId', selectedCenter.value.CODE);
            data.append('time', selectedTime.value);
            data.append('type', 'service');
            data.append('tiresStored', +tiresStored.value ? 1 : 0);
            data.append('contractNum', client.value.contractNumber);
            data.append('date', selectedDate.value);
            data.append('licenseNumber', car.value.licenseNumber);
            // data.append('vinNumber', car.value.vinNumber);
            data.append('carBrand', car.value.brand);
            data.append('carModel', car.value.model);
            // data.append('carYear', car.value.year);
            // data.append('carShell', car.value.shell);
            data.append('client', client.value.name);
            // data.append('mileage', this.mileage);
            data.append('phone', client.value.phone);
            data.append('customAddress', '');
            data.append('lat', 0);
            data.append('lng', 0);
            data.append('services[]', selectedService.value.UF_CODE || 21834);

            // if ( this.mobileServiceSelected )
            // {
            //     data.comment = this.mobileServiceData.clarificationAddress;
            //     data.lat = +this.mobileServiceData.coordinates[ 0 ];
            //     data.lng = +this.mobileServiceData.coordinates[ 1 ];
            //     data.customAddress = this.mobileServiceData.address;
            // }
            submitServiceOrder(data).then(res => {
                if (res.id) {
                    order.value.id = res.id;
                    openCompletePopup();
                    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && res.icsFileLink) {
                        calendarLink.value = res.icsFileLink;
                    }
                    else {
                        if (res.googleCalendarLink) {
                            calendarLink.value = res.googleCalendarLink;
                        }
                    }
                }
                if (res.message) {
                    showMessage(res.message);
                }
            })
        };

        const goTo = url => window.location.href = url;

        const contractNumberChecked = ref(false);
        const checkContractNumber = () => {
            if (client.value.contractNumber && selectedCenter.value.CODE) {
                getTireStoreContract(client.value.contractNumber).then(res => {
                    if (res.success) {
                        contractNumberChecked.value = true;
                        if (res.data.UF_CONTRACT_PLACE != selectedCenter.value.CODE) {
                            client.value.contractNumber = '';
                            if (res.data.ADDRESS) {
                                showMessage(`Ваши шины хранятся в СЦ - ${res.data.ADDRESS}`);
                            }
                        }
                    }
                    else {
                        client.value.contractNumber = '';
                    }
                    if (res.message) {
                        showMessage(res.message);
                    }
                });
            }
        }

        const mapPlacemarks = computed(() => {
            let mapPlacemarks = [];
            for (var i = 0; i < availableCenters.value.length; i++) {
                if (availableCenters.value[i].LAT && availableCenters.value[i].LNG) {
                    mapPlacemarks.push({
                        center : availableCenters.value[i],
                        coords : [ availableCenters.value[i].LAT, availableCenters.value[i].LNG ]
                    });
                }
            }
            return mapPlacemarks;
        })

        const mapPlacemarkSelected = ({item}) => {
            if (item.center.ID) {
                selectedCenterId.value = item.center.ID;
            }
        }

        const favCenter = computed(() => {
            let favCenterXmlId = initData.value.UF_FV_SERVICE_CENTER;
            if (!favCenterXmlId) {
                return {};
            }
            return (availableCenters.value||[]).find(c => c.CODE == favCenterXmlId) || {};
        });
        selectedCenterId.value = favCenter.value.ID;
        watch(favCenter, () => {
            selectedCenterId.value = favCenter.value.ID;
        });

        return {
            favCenter,
            contractNumberChecked,
            checkContractNumber,
            mapPlacemarks,
            mapPlacemarkSelected,
            goTo,
            calendarLink,
            tireFittingPricePopup,
            personalCars,
            selectedPersonalCarId,
            selectedService,
            selectedServiceCode,
            selectServiceType,
            selectTime,
            submit,

            serviceOrderCompletePopup,

            tiresStored,
            order,
            client,
            selectedDateFormatted,
            selectedDate,
            selectedTime,
            car,
            selectedCenterId,
            selectedCenter,
            availableCenters,
            availableTime,
            availableTimeLoaded,
            selectedServices,
        };
    }
}
</script>
